module.exports = __webpack_public_path__ + "static/media/171IT154.92043aa2.png";